import React, { useState } from "react";
import "./Adjuster.css";

const Adjuster = () => {
  // Array of items with base price and discounted prices at different quantities
  const items = [
    {
      name: "Original Littman stethoscope case",
      price: 3550,
      discountPrices: {
        25: 3450,
        50: 3350,
        100: 3250,
        200: 3250,
      },
    },
    {
      name: "Triple Layer stethoscope case",
      price: 3350,
      discountPrices: {
        25: 3250,
        50: 3150,
        100: 2990,
        200: 2990,
      },
    },
    {
      name: "Adult heavy Knee hammer",
      price: 1990,
      discountPrices: {
        25: 1900,
        50: 1850,
        100: 1800,
        200: 1800,
      },
    },
    {
      name: "Pen torch (AAA Battery)",
      price: 790,
      discountPrices: {
        25: 750,
        50: 720,
        100: 690,
        200: 690,
      },
    },
    {
      name: "USB Rechargeable pen torch",
      price: 1590,
      discountPrices: {
        25: 1490,
        50: 1450,
        100: 1390,
        200: 1390,
      },
    },
    {
      name: "Measuring tape",
      price: 95,
      discountPrices: {
        25: 90,
        50: 85,
        100: 80,
        200: 80,
      },
    },
  ];
  
  

  // State to track the selected item and quantity
  const [selectedItemIndex, setSelectedItemIndex] = useState(0);
  const [quantity, setQuantity] = useState(25);

  // Get the selected item's details
  const selectedItem = items[selectedItemIndex];

  // Calculate standard and discount prices
  const standardPricePerItem = selectedItem.price;
  const discountPricePerItem = selectedItem.discountPrices[quantity];
  
  // Calculate total prices
  const totalStandardPrice = standardPricePerItem * quantity;
  const totalDiscountPrice = discountPricePerItem * quantity;
  
  // Calculate total savings
  const totalSaving = totalStandardPrice - totalDiscountPrice;

  return (
    <div className="bg-white mx-4 sm:mx-0 sm:w-[480px] sm:h-[620px] rounded-lg" data-aos="zoom-in">
      <div className="flex items-center justify-center">
        <div className="rounded-lg shadow-lg p-4 sm:p-8 w-full">
          <h1 className="text-3xl font-bold text-center text-_dark mb-4">
            ADJUST & SAVE
          </h1>
          <p className="text-center text-_gray text-sm mb-6">
            Find the perfect deal by adjusting the quantity of your purchase!
            See how much you can save when you buy more.
          </p>

          <div className="mb-6 border py-3 px-2 rounded-sm shadow-sm">
            <select
              className="w-full text-_gray focus:ring-0 focus:outline-none"
              onChange={(e) => setSelectedItemIndex(Number(e.target.value))}
              value={selectedItemIndex}
            >
              {items.map((item, index) => (
                <option key={index} value={index} className="px-2 focus:ring-0 focus:outline-none">
                  {item.name}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-6">
            <p className="text-lg font-semibold text-_dark mb-4">
              Select your count
            </p>
            <div className="flex items-center justify-between">
              <span>25</span>
              <input
                type="range"
                min="0"
                max="3"
                step="1"
                value={quantity === 25 ? 0 : quantity === 50 ? 1 : quantity === 100 ? 2 : 3}
                onChange={(e) => setQuantity([25, 50, 100, 200][e.target.value])}
                className="w-full mx-4"
              />
              <span>200</span>
            </div>
            <div className="flex justify-between text-xs text-_gray mt-1">
              <span className=" opacity-0">25</span>
              <span className=" translate-x-3">50</span>
              <span className=" -translate-x-3">100</span>
              <span className=" opacity-0">200</span>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row justify-between items-center mb-6 gap-4 ">
            <div className="p-4 rounded-lg shadow-md w-full sm:w-1/2">
              <div className="flex flex-row justify-between text-xs font-semibold">
                <p className="text-_gray">Standard Price</p>
                <p className="text-_gray">Size: {quantity}</p>
              </div>
              <div className="flex flex-row justify-between text-xs text-_white bg-_gray py-1 px-1 rounded-sm my-8">
                <p className="">For one item</p>
                <p className="">Rs. {standardPricePerItem}</p>
              </div>
              <div className="flex flex-row justify-between items-center text-xs text-_white rounded-sm">
                <p className="text-_gray">Total</p>
                <p className="bg-_gray py-1 px-3 rounded-full">
                  Rs. {totalStandardPrice}
                </p>
              </div>
            </div>
            <div className="p-4 rounded-lg shadow-md w-full sm:w-1/2">
              <div className="flex flex-row justify-between text-xs font-semibold text-_gray">
                <p className="">Discount price</p>
                <p className="">Size: {quantity}</p>
              </div>
              <div className="flex flex-row justify-between text-xs text-_white bg-_dark py-1 px-1 rounded-sm my-8">
                <p className="">For one item</p>
                <p className="">Rs. {discountPricePerItem}</p>
              </div>
              <div className="flex flex-row justify-between items-center text-xs text-_white rounded-sm">
                <p className="text-_gray">Total</p>
                <p className="bg-_dark py-1 px-3 rounded-full">
                  Rs. {totalDiscountPrice}
                </p>
              </div>
            </div>
          </div>

          <div className="text-center">
            <p className="text-2xl font-semibold text-_dark">
              You Saved!
            </p>
            <p className="text-3xl font-bold text-_red">Rs. {totalSaving}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Adjuster;